import { BaseTooltipAction, TooltipState } from '../../types';

type DonationSettingsTooltipAction = BaseTooltipAction;

interface GetBaseTooltipReducerParams {
    successLabel: string;
    errorLabel?: string;
}

export const getBaseTooltipReducer =
    ({ successLabel, errorLabel }: GetBaseTooltipReducerParams) =>
    (state: TooltipState, action: DonationSettingsTooltipAction): TooltipState => {
        switch (action) {
            case 'error':
                return {
                    tooltipVisible: true,
                    tooltipTheme: 'error',
                    tooltipLabel: errorLabel ?? 'Произошла ошибка',
                };
            case 'ok':
                return {
                    tooltipVisible: true,
                    tooltipTheme: 'normal',
                    tooltipLabel: successLabel,
                };
            case 'clear':
                return {
                    tooltipVisible: false,
                };
        }
    };
